"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const TextInput_1 = __importDefault(require("../TextInput"));
const StyledTextInput = (0, styled_components_1.default)(TextInput_1.default) `
  .MuiInputBase-root {
    padding: 0;
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;
/**
 * A generic text-area component with form label.
 * Extends MUI's [MUI's TextField component](https://mui.com/material-ui/react-text-field/).
 * */
const TextArea = ({ rows = 5, ...rest }) => ((0, jsx_runtime_1.jsx)(StyledTextInput, { multiline: true, rows: rows, ...rest }));
exports.default = TextArea;
//# sourceMappingURL=index.js.map